import type { ServiceDefinition } from './types';

export const BaseService: Omit<ServiceDefinition, 'name' | 'formattedName'> = {
  charLimit: null,
  previewCharLimit: null,
  previewCharLimitWithMedia: null,
  previewTitleCharLimit: null,
  titleCharLimit: null,
  commentCharLimit: null,
  doesRequireHumanInteractionToUpdateText: false,
  unavailableAttachmentTypes: [],
  requiredAttachmentType: null,
  unavailableMediaAttachmentTypes: [],
  maxAttachableImagesCount: 1,
  maxHashtags: null, // No maximum by default
  maxMentions: null, // No maximum by default
  nativeVideoSizeLimit: null,
  nativeVideoDurationLimit: null,
  attachmentMinSize: null,
  videoMaxSize: null,
  videoMinResolution: null,
  videoMinDurationMs: null,
  videoMaxDurationMs: null,
  videoMaxAspectRatio: null,
  videoMinAspectRatio: null,
  videoMaxWidth: null,
  videoMinFrameRate: null,
  videoMaxFrameRate: null,
  videoMaxAspectRatioHumanReadable: null,
  videoMinAspectRatioHumanReadable: null,
  videoMaxSizeReels: null,
  gifMaxSize: null,
  imageMaxSize: null,
  imageMaxWidth: null,
  imageMaxHeight: null,
  hasSubprofiles: false,
  canHaveSourceUrl: false,
  requiresText: false,
  requiresSourceUrl: false,
  canEditLinkAttachment: false,
  canEditVideoAttachment: false,
  canHaveLocation: false,
  canHaveUserTags: false,
  usesImageFirstLayout: false,
  isOmni: false,
  transcodeVideo: false,
  canEditVideoTitle: false,
  onlyAllowsVerticalVideo: false,
  shouldShowDuplicateContentWarning: false,
  // Reels
  videoMinAspectRatioReels: null,
  videoMaxAspectRatioReels: null,
  videoMinDurationMsReels: null,
  videoMaxDurationMsReels: null,
  videoMinAspectRatioHumanReadableReels: null,
  videoMaxAspectRatioHumanReadableReels: null,
  // Stories
  videoMinAspectRatioStories: null,
  videoMaxAspectRatioStories: null,
  videoMinDurationMsStories: null,
  videoMaxDurationMsStories: null,
  videoMinAspectRatioHumanReadableStories: null,
  videoMaxAspectRatioHumanReadableStories: null,
  videoMaxSizeStories: null,
  imageMaxSizeStories: null,

  canHaveAttachmentType(this: ServiceDefinition, type) {
    return !this.unavailableAttachmentTypes.includes(type);
  },

  canHaveSomeAttachmentType(this: ServiceDefinition, types) {
    return types.some((type) => this.canHaveAttachmentType(type));
  },

  canHaveMediaAttachmentType(this: ServiceDefinition, type) {
    return !this.unavailableMediaAttachmentTypes.includes(type);
  },

  canHaveSomeMediaAttachmentTypes(this: ServiceDefinition, types) {
    return types.some((type) => this.canHaveMediaAttachmentType(type));
  },

  isTiktok(this: ServiceDefinition) {
    return this.name === 'tiktok';
  },

  isInstagram(this: ServiceDefinition) {
    return this.name === 'instagram';
  },

  isFacebook(this: ServiceDefinition) {
    return this.name === 'facebook';
  },

  isTwitter(this: ServiceDefinition) {
    return this.name === 'twitter';
  },

  isPinterest(this: ServiceDefinition) {
    return this.name === 'pinterest';
  },

  isLinkedin(this: ServiceDefinition) {
    return this.name === 'linkedin';
  },

  isGoogleBusiness(this: ServiceDefinition) {
    return this.name === 'googlebusiness';
  },

  isStartPage(this: ServiceDefinition) {
    return this.name === 'startPage';
  },

  isMastodon(this: ServiceDefinition) {
    return this.name === 'mastodon';
  },

  isYoutube(this: ServiceDefinition) {
    return this.name === 'youtube';
  },
};
